import React from 'react';
import { StyleSheet } from 'react-native';
import {
  BodyText,
  Button,
  Card,
  HStack,
  theme,
  TitleText,
  useBreakpointHelpers,
} from '@sg/garnish';

import { getSweetpassBenefitsScreenCardPaletteForTag } from './SweetpassBenefitScreenPalette';
import type {
  SweetpassBenefitsCardsSection,
  SweetpassBenefitsPageCardCtaHandler,
} from './SweetpassBenefitsScreen.loaded';

export const SweetpassBenefitsPageCardsContent = ({
  content,
  ctaHandler,
}: SweetpassBenefitsPageCardsContentProps) => {
  const { isMobile, matchByBreakpointIndex } = useBreakpointHelpers();

  return (
    <HStack
      style={styles.container}
      testID="sweetpass-benefits-cards"
      itemsPerRow={2}
    >
      {content.cards.map((card) => {
        const palette = getSweetpassBenefitsScreenCardPaletteForTag(
          card.palette,
        );

        return (
          <Card
            key={card.id}
            testID={`sweetpass-benefits-card-${card.id}`}
            style={[styles.card, isMobile ? styles.cardMobile : {}]}
            backgroundColor={palette.backgroundColor}
          >
            <BodyText
              style={styles.cardTitle}
              size={matchByBreakpointIndex([5, 5, 4, 4])}
            >
              {card.title}
            </BodyText>
            <TitleText
              style={styles.cardText}
              size={matchByBreakpointIndex([6, 5, 4, 4])}
            >
              {card.description}
            </TitleText>

            <Button
              style={matchByBreakpointIndex([
                styles.ctaMobile,
                styles.ctaDesktop,
              ])}
              testID={`sweetpass-benefits-card-${card.id}-cta`}
              palette="secondary"
              size={matchByBreakpointIndex([
                'small',
                'medium',
                'large',
                'large',
              ])}
              onPress={() => {
                ctaHandler(card.cta.action);
              }}
            >
              {card.cta.title}
            </Button>
          </Card>
        );
      })}
    </HStack>
  );
};

type SweetpassBenefitsPageCardsContentProps = {
  readonly content: SweetpassBenefitsCardsSection;
  readonly ctaHandler: SweetpassBenefitsPageCardCtaHandler;
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingTop: theme.spacing.xlarge,
  },
  card: {
    alignItems: 'center',
    padding: theme.spacing.large + theme.spacing.xlarge,
  },
  cardMobile: {
    padding: theme.spacing.medium,
  },
  cardTitle: {
    textTransform: 'uppercase',
  },
  cardText: {
    paddingTop: theme.spacing.small,
    marginBottom: theme.spacing.large,
    textAlign: 'center',
  },
  ctaDesktop: {
    paddingHorizontal: theme.spacing.xlarge,
  },
  ctaMobile: {
    paddingHorizontal: theme.spacing.medium,
  },
});
